module.exports = __webpack_public_path__ + "img/link.31493bf1.svg";